export default function(state = {}, action) {
  const typeMap = {
    BRANDS_THAT_MATTER_LIST_PAGE_LOADING() {
      return {
        isLoading: true,
        brandsThatMatterListPage: action.brandsThatMatterListPage
      };
    },
    BRANDS_THAT_MATTER_LIST_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.brandsThatMatterListPage
      };
    },
    BRANDS_THAT_MATTER_LIST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.brandsThatMatterListPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
